// ** React Imports
import { useState } from 'react'
import Box from '@mui/material/Box'
import CardHeader from '@mui/material/CardHeader'
import Grid from '@mui/material/Grid'
import {
  Divider,
  Fab,
  Card,
  CardContent,
  Typography,
  Button,
} from '@mui/material'
import { useNavigate } from 'react-router-dom'
import Swal from 'sweetalert2'
import Icon from '../../../../components/icon'
import MsiDatagridAuto from '../../../../components/custom/MsiDatagridAuto'
import apiUrl from '../../../../configs/constant'
import axios from 'axios'
import { useToast } from '../../../../components/ToastProvider'

export default function Index() {
  const userData = JSON.parse(localStorage.getItem('user')!)
  const token = userData.token
  const { showToast, hideToast } = useToast();
  const navigate = useNavigate()

  // ** State
  const [listData, setListData] = useState<any[]>([])
  const [summary, setSummary] = useState({
    success_count: 0,
    failed_count: 0,
    duplicate_count: 0,
  })
  const [importId, setImportId] = useState<number | null>(null)

  const handleImportFile = () => {
    const inputFile = document.createElement('input')
    inputFile.type = 'file'
    inputFile.accept = '.xlsx,.xls'
    inputFile.onchange = (e: any) => {
      const file = e.target.files[0]
      if (!file) return

      const formData = new FormData()
      formData.append('file', file)

      Swal.fire({
        title: 'Now loading',
        allowEscapeKey: false,
        allowOutsideClick: false,
        didOpen: () => Swal.showLoading()
      })

      axios
        .post(apiUrl.apiUrl + '/sales/pos/import-bigseller', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${token}`
          }
        })
        .then(response => {
          Swal.close()
          const res = response.data
          if (res.success) {
            setListData(res.data || [])
            setSummary({
              success_count: res.success_count || 0,
              failed_count: res.failed_count || 0,
              duplicate_count: res.duplicate_count || 0
            })
            setImportId(res.import_id || null)
            showToast(res.message, 'success')
          } else {
            showToast(res.message, 'error')
          }
        })
        .catch(error => {
          Swal.close()
          showToast(error.message, 'error')
        })
    }

    inputFile.click()
  }

  const handleSaveImport = () => {
    if (!importId) {
      showToast('Tidak ada data import yang bisa disimpan.', 'warning')
      return
    }

    Swal.fire({
      title: 'Konfirmasi',
      text: 'Apakah Anda yakin ingin menyimpan hasil import ini ke database?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Ya, Simpan',
      cancelButtonText: 'Batal'
    }).then(result => {
      if (result.isConfirmed) {
        Swal.fire({
          title: 'Menyimpan...',
          allowEscapeKey: false,
          allowOutsideClick: false,
          didOpen: () => Swal.showLoading()
        })

        axios
          .post(
            apiUrl.apiUrl + '/sales/pos/commit-import',
            { import_id: importId },
            { headers: { Authorization: `Bearer ${token}` } }
          )
          .then(res => {
            Swal.close()
            if (res.data.success) {
              showToast('Data import berhasil disimpan.', 'success')
              navigate(-1)
            } else {
              showToast(res.data.message, 'error')
            }
          })
          .catch(err => {
            Swal.close()
            showToast(err.message, 'error')
          })
      }
    })
  }

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <div className='content-block dx-card'>
          {/* Header */}
          <Box
            sx={{
              width: '100%',
              display: 'flex',
              flexWrap: 'wrap',
              alignItems: 'center',
              justifyContent: 'space-between'
            }}
          >
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <CardHeader title='IMPORT BIGSELLER' />
            </Box>

            <Box sx={{ display: 'flex', alignItems: 'center', mr: 2 }}>
              <Fab color='primary' size='medium' onClick={handleImportFile} sx={{ mr: 2 }}>
                <Icon icon='mdi:plus' fontSize={35} color='white' />
              </Fab>
              <Button
                variant='contained'
                color='success'
                onClick={handleSaveImport}
                disabled={!importId}
              >
                Simpan Import
              </Button>
            </Box>
          </Box>

          <Divider sx={{ mb: 3 }} />

          {/* Summary Cards */}
          <Grid container spacing={3} sx={{ mb: 2 }}>
            <Grid item xs={12} sm={4}>
              <Card sx={{ backgroundColor: '#e8f5e9', borderLeft: '6px solid #2e7d32' }}>
                <CardContent>
                  <Typography variant='h6' color='success.dark'>
                    ✅ Data Valid
                  </Typography>
                  <Typography variant='h4' fontWeight='bold' color='#000'>
                    {summary.success_count}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>

            <Grid item xs={12} sm={4}>
              <Card sx={{ backgroundColor: '#fff3e0', borderLeft: '6px solid #ef6c00' }}>
                <CardContent>
                  <Typography variant='h6' color='warning.dark'>
                    ⚠️ Duplikat
                  </Typography>
                  <Typography variant='h4' fontWeight='bold' color='#000'>
                    {summary.duplicate_count}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>

            <Grid item xs={12} sm={4}>
              <Card sx={{ backgroundColor: '#ffebee', borderLeft: '6px solid #c62828' }}>
                <CardContent>
                  <Typography variant='h6' color='error.dark'>
                    ❌ Error
                  </Typography>
                  <Typography variant='h4' fontWeight='bold' color='#000'>
                    {summary.failed_count}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          </Grid>

          {/* DataGrid */}
          <MsiDatagridAuto
            key={1}
            array={listData}
            hiddenColumns={[
              'is_success',
              'is_duplicate',
              'is_error',
              'pos_import_id',
              'id'
            ]}
          />
        </div>
      </Grid>
    </Grid>
  )
}
